// apiUtility.ts
import { env } from '../environment.template';
import CryptoJS from 'crypto-js';

const SECRET_KEY: string =
  env.cryptoKey || 'defaultSecretKey';

export const encrypted = {
  async encrypt(text: string): Promise<string> {
    // Use the same CryptoJS method as utility.tsx
    const parsedBase64Key = CryptoJS.enc.Base64.parse(SECRET_KEY);
    const iv = CryptoJS.lib.WordArray.random(16);

    const encryptedData = CryptoJS.AES.encrypt(text, parsedBase64Key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    // Prepend the IV to the encrypted text
    const ivAndCipherText = iv.concat(encryptedData.ciphertext).toString(CryptoJS.enc.Base64);

    return ivAndCipherText;
  },

  async decrypt(
    encryptedInput: string | { encryptedBody: string }
  ): Promise<string> {
    try {
      const encryptedStr =
        typeof encryptedInput === 'string'
          ? encryptedInput
          : encryptedInput.encryptedBody;

      if (
        !encryptedStr ||
        typeof encryptedStr !== 'string'
      ) {
        throw new Error('Invalid encrypted input');
      }

      const parsedBase64Key = CryptoJS.enc.Base64.parse(SECRET_KEY);
      const decodedText = CryptoJS.enc.Base64.parse(encryptedStr);
      const iv = CryptoJS.lib.WordArray.create(decodedText.words.slice(0, 4));
      const cipherText = CryptoJS.lib.WordArray.create(decodedText.words.slice(4));

      const cipherParams = CryptoJS.lib.CipherParams.create({
        ciphertext: cipherText
      });

      const decryptedData = CryptoJS.AES.decrypt(
        cipherParams,
        parsedBase64Key,
        {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }
      );

      const decryptedText = decryptedData.toString(CryptoJS.enc.Utf8);
      
      if (!decryptedText) {
        throw new Error('Decryption returned empty result');
      }

      return decryptedText;
    } catch (err) {
      console.error('Decryption error:', err);
      throw err;
    }
  },
};
